// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2xyXV","colMaxWidth":"Table_colMaxWidth__3wRqV"};